var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('dictionary-modal-table',{attrs:{"dictionary_link":"/orgin-countries","title":"Lista krajów pochodzenia","numeral_text":[
      'kraj pochodzenia',
      'kraje pochodzenia',
      'krajów pochodzenia' ],"columns_title":['name']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }